module.exports = __webpack_public_path__ + "media/two-coin2.b8b17001.mp3";